import { createContext } from 'react';

const FeaturesContext = /*#__PURE__*/createContext(undefined);

export { FeaturesContext };
